<!-- EnviosView.vue -->
<template>
  <div class="envios-view">
    <div class="header-section">
      <div class="title-container">
        <h1>Gestión de Envios</h1>
        <button class="primary-button" @click="openCreateModal">
          <Plus />
          Nuevo Envio
        </button>
      </div>
      <EnvioSearchComponent />
    </div>
    
    <!-- <IncidentFilters @filter="handleFilter" /> -->

    <EnvioListComponent />
    <!-- <IncidentListComponentAux /> -->
    <EnvioFormComponent
      :show="isFormModalOpen"
      @close="handleCloseModal"
      @submit="handleFormSubmit"
    />

  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from 'vue';
import { useEnviosStore } from '@/stores/useEnvioStore';
/* import IncidentActions from '@/components/incidents/IncidentActions.vue';
import IncidentFilters from '@/components/incidents/IncidentFilters.vue'; */
import EnvioListComponent from '@/components/envios/EnvioListComponent.vue';
import EnvioSearchComponent from '@/components/envios/EnvioSearchComponent.vue';
import EnvioFormComponent from '@/components/envios/EnvioFormComponent.vue';
/* import IncidentFormModal from '@/components/incidents/IncidentFormModal.vue'; */
import type { Envio } from '@/types/envioTypes';

import { Plus } from 'lucide-vue-next';

// Store
const enviosStore = useEnviosStore();

// State
const isFormModalOpen = ref(false);
const selectedEnvio = ref<Envio | null>(null);
/* const currentFilters = ref<IncidentFilters>({}); */

// Computed
const filteredEnvios = computed(() => {
  return enviosStore.envios.filter(envio => {
    // Lógica de filtrado según currentFilters
  });
});

// Handlers
const handleFormSubmit = async () => {
  await enviosStore.fetchEnvios();
}

const handleCloseModal = () => {
  isFormModalOpen.value = false;
};

const openCreateModal = () => {
  selectedEnvio.value = null;
  isFormModalOpen.value = true;
};

const openEditModal = (envio: Envio) => {
  selectedEnvio.value = envio;
  isFormModalOpen.value = true;
};
/* 
const handleFormSubmit = async (formData: IncidentForm) => {
  if (selectedIncident.value) {
    await incidentStore.updateIncident(formData);
  } else {
    await incidentStore.createIncident(formData);
  }
  isFormModalOpen.value = false;
}; */

const refreshEnvios = async () => {
  await enviosStore.fetchEnvios();
};

// Inicialización
onMounted(() => {
  enviosStore.fetchEnvios();
});
</script>

<style scoped>
.envios-view {
  padding: 2rem;
  max-width: 1200px;
  margin: 0 auto;
}

.header-section {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  margin-bottom: 2rem;
}

.title-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
}

.primary-button {
  background: #2196F3;
  color: white;
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  transition: background 0.3s ease;
  font-size: 1rem;
  order: 2; /* Para móviles lo ponemos debajo */
}

.primary-button:hover {
  background: #1976D2;
}

@media (min-width: 768px) {
  .primary-button {
    order: 1; /* En desktop volvemos al orden normal */
  }
}
</style>
